module.exports = __webpack_public_path__ + "static/media/foodshot25.5484f303.JPG";